export const screenSizes = {
    xxs: 0,
    xs: 600,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1440,
};
export const pageOffsets = {
    xxs: 16,
    xs: 16,
    sm: 32,
    md: 64,
    lg: 124,
};
export const maxPageContentWidth = screenSizes.xl - pageOffsets.lg * 2;
//# sourceMappingURL=index.js.map